import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate, testPrintData, showMessageToast, isNullOrEmpty, showMessageToastCustom } from '../../../utils/util';
import { BackButton, Title, Subtitle, Select, Input, Button, ScannerCode } from '../../../components/UI/ComponentsUI';
import * as configAction from '../../../actions/configAction';
import { ENUMS } from '../../../utils/constants';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import ConfigurationService from '../../../services/ConfigurationService';

const PrintTest = (props) => {
    const [model, setModel] = useState({
        print: null,
        text: ""
    });
    const [printer, setPrinter] = useState();

    useEffect(() => {
        props.getPrints(props.user.vision, {});
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };


    const sendPrinter = () => {
        if (printer && !isNullOrEmpty(model.text)) {
            if (printer?.connectionType === ENUMS.ePrinterConnectionType.Wifi.value) {
                props.sendPrintTeste(printer.address, printer.port, model.text, (response) => {
                    showMessageToast({ html: `${response} - Enviado para ${printer.address}:${printer.port}`, classes: 'green' });
                })
            } else {
                showMessageToast({ html: `Enviado para ${printer.macAddress}`, classes: 'green' });
                window.onMessageMobile = function (e) {
                    showMessageToastCustom(translate('warning', 'general'), e?.message || "Error", 8000, 'mdi mdi-alert-circle-outline red-text');
                };
                testPrintData(printer.macAddress, model.text, printer.printerManufacture);
            }
        }
    }

    const changePrinter = (event) => {
        var printer = props.prints?.items.find((f) => f.printerId === parseInt(event.target.value));

        if (printer) {
            setPrinter(printer)
        } else {
            showMessageToast({ html: `Impressora não encontrada`, classes: 'red' });
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('menu.configuration', 'configuration')} />
                    <Subtitle icon="mdi mdi-printer" label={translate('menu.printer', 'configuration')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formPrint" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Select
                                        required
                                        id="print"
                                        name="print"
                                        placeHolder={translate('fields.print', 'resource')}
                                        data={props.prints?.items ? props.prints?.items.map((i) => { return { id: i.printerId, text: i.name }; }) : []}
                                        change={(evt) => {
                                            onChange(evt);
                                            changePrinter(evt);
                                        }}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        required={printer?.connectionType !== ENUMS.ePrinterConnectionType.Wifi.value}
                                        label="Comando Documento"
                                        id="text"
                                        name="text"
                                        type="text"
                                        onChange={onChange}
                                        defaultValue={model.text || ''} />
                                    <ScannerCode className={"mdi mdi-qrcode posfix"} onScanner={(value) => {
                                        model.text = value;
                                        setModel({ ...model });
                                    }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ paddingTop: '10px' }}>
                        <Button full="true" onClick={sendPrinter} text="Imprimir" />
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.locationReducer.filter,
        prints: state.configReducer.prints
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPrints: (vision, filter) => {
            dispatch(ConfigurationService.getPrints(vision, filter));
        },
        sendPrintTeste: (ipAddress, port, ZPLString, callback) => {
            dispatch(ConfigurationService.TestePrintServer(ipAddress, port, ZPLString, callback));
        },
        setPrint: (print) => {
            dispatch(configAction.setPrint(print));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrintTest));
